import Vue from '../../helpers/VueBase';
import Sentry from './Sentry.vue';

new Vue({
  render: h => h(Sentry),
}).$mount(`.sentry-vue`);
